import React from 'react';

// Classification mirrors CountInterface's getSessionSection / Reports'
// classifySession: order runs are anything with order calculations on;
// EOP runs are period-end / full-inventory counts (legacy inventory_mode
// values included for pre-migration sessions). Exported so the completion
// flow classifies a finished session with the same rule as these pills.
export const isEOPSession = (s) => {
  const cp = s?.count_purpose || '';
  const im = s?.inventory_mode || '';
  return cp === 'period_end' || cp === 'full_inventory' || im === 'Financial' || im === 'Both';
};

// Report-type ids match Reports.jsx REPORT_TYPES so each pill executes the
// exact same generator the reports page runs.
const pillsForSession = (session) => {
  if (session?.order_calculations_enabled === true) {
    return [{ type: 'order', label: 'Order Report', icon: '🛒' }];
  }
  return [
    ...(isEOPSession(session) ? [{ type: 'cogs', label: 'P&L', icon: '📊' }] : []),
    { type: 'detail', label: 'Inventory Detail', icon: '📋' },
    { type: 'value', label: 'Inventory Value', icon: '💰' },
  ];
};

/**
 * "Available Reports" frame shown in the middle of a count card once the
 * run is marked complete. Pills open the matching report in a modal frame
 * on the count page (via the embedded Reports component) instead of
 * navigating to reports.html.
 */
const CountCardAvailableReports = ({ session, onOpenReport, compact = false }) => {
  if (!session || session.status !== 'completed') return null;
  const pills = pillsForSession(session);
  if (!pills.length) return null;

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        border: '1px solid #E8DDD0',
        backgroundColor: '#FDFAF6',
        borderRadius: '8px',
        padding: compact ? '6px 8px 7px' : '7px 10px 8px',
      }}
    >
      <div style={{
        fontSize: '0.58rem',
        fontWeight: 700,
        color: '#9B8B83',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        marginBottom: '5px',
        whiteSpace: 'nowrap',
      }}>
        Available Reports
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
        {pills.map((pill) => (
          <button
            key={pill.type}
            type="button"
            title={`Open the ${pill.label} report for this count without leaving this page`}
            onClick={(e) => {
              e.stopPropagation();
              onOpenReport(pill.type, session);
            }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#F5EDE4'; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#FFFFFF'; }}
            style={{
              fontSize: compact ? '0.66rem' : '0.68rem',
              fontWeight: 600,
              padding: compact ? '3px 9px' : '3px 11px',
              borderRadius: '999px',
              border: '1px solid #C9B8A8',
              backgroundColor: '#FFFFFF',
              color: '#5A4A42',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '4px',
              lineHeight: 1.4,
              transition: 'background-color 0.12s',
            }}
          >
            <span aria-hidden="true" style={{ fontSize: compact ? '0.7rem' : '0.75rem', lineHeight: 1 }}>{pill.icon}</span>
            {pill.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CountCardAvailableReports;
